export default function fixServicesLinksHeight()
{
    const parent = document.querySelector(".services-links");
    if (!parent) return;

    const cards = parent.querySelectorAll(".service-item");
    if (cards.length == 0) return;

    var maxHeight = 0;
    for (let card of cards) {
        $(card).removeAttr("style");
        maxHeight = Math.max(maxHeight, $(card).height());
    }

    for (let card of cards) {
        $(card).height(maxHeight);
    }
}